import React, { useMemo, useState } from "react";
import { Box, Flex, Tab, Tabs, Text } from "@chakra-ui/react";
import { MilestoneItem } from "./MilestoneItem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const tabs = {
  0: {
    name: "Completed",
    filter: milestone => !!milestone.completed
  },
  1: {
    name: "Pending",
    filter: milestone => !milestone.completed
  }
};
export const MilestoneList = _ref => {
  let {
    milestones
  } = _ref;
  const [selectedTab, setSelectedTab] = useState(0);
  const amounts = useMemo(() => Object.values(tabs).map(_ref2 => {
    let {
      filter
    } = _ref2;
    return milestones.filter(filter).length;
  }), [milestones]);
  const showing = useMemo(() => milestones.filter(tabs[selectedTab].filter), [selectedTab, milestones]);
  const getAmountTextProps = index => {
    const isSelected = selectedTab === index;
    return {
      color: isSelected ? "blue" : "gray.500",
      bg: isSelected ? "blue.100" : "gray.200"
    };
  };
  const getTabProps = index => {
    const isSelected = selectedTab === index;
    return {
      color: "black",
      border: "none",
      rounded: "3xl",
      py: 1,
      px: 3,
      _notFirst: {
        ml: 2
      },
      mt: "-2px",
      fontWeight: isSelected ? "semibold" : "normal",
      bg: isSelected ? "white" : "transparent",
      shadow: isSelected ? "sm" : "none"
    };
  };
  const getBadgeTitle = milestone => {
    const type = milestone.isGrantUpdate ? "Update" : "Milestone";
    let count = 0;
    for (const item of showing) {
      count += item.isGrantUpdate === milestone.isGrantUpdate ? 1 : 0;
      if (milestone.uid === item.uid) break;
    }
    return `${type} ${count}`;
  };
  const milestoneCount = milestones.filter(milestone => !milestone.isGrantUpdate).length;
  return /*#__PURE__*/_jsxs(Box, {
    py: 3,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      className: "justify-center md:justify-between",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsxs(Flex, {
        gap: 5,
        alignItems: "center",
        className: "justify-center md:justify-normal",
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Text, {
            mt: "-5px",
            fontWeight: "semibold",
            children: "Milestones"
          })
        }), /*#__PURE__*/_jsx(Box, {
          bg: "gray.100",
          borderRadius: "3xl",
          p: 1.5,
          children: /*#__PURE__*/_jsx(Tabs, {
            display: "flex",
            onChange: setSelectedTab,
            borderRadius: "2xl",
            children: Object.keys(tabs).map((key, index) => /*#__PURE__*/_jsx(Tab, {
              ...getTabProps(index),
              fontSize: ["xs", "sm"],
              children: /*#__PURE__*/_jsxs(Flex, {
                gap: 3,
                alignItems: "center",
                children: [/*#__PURE__*/_jsx(Box, {
                  mt: "-2px",
                  children: tabs[+key].name
                }), /*#__PURE__*/_jsx(Flex, {
                  ...getAmountTextProps(index),
                  px: 3,
                  borderRadius: "xl",
                  children: /*#__PURE__*/_jsx(Text, {
                    mt: "-2px",
                    fontWeight: "semibold",
                    children: amounts[index]
                  })
                })]
              })
            }, +key))
          })
        })]
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsxs("small", {
            children: [milestoneCount, " milestones, ", milestones.length - milestoneCount, " ", "updates in this grant."]
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Box, {
      pt: 7,
      children: showing.length > 0 ? /*#__PURE__*/_jsx(Flex, {
        gap: 5,
        flexDir: "column",
        children: showing.map((milestone, index) => /*#__PURE__*/_jsx(MilestoneItem, {
          milestone: milestone,
          badgeTitle: getBadgeTitle(milestone)
        }, +index))
      }) : /*#__PURE__*/_jsx(Box, {
        textAlign: "center",
        children: /*#__PURE__*/_jsxs(Text, {
          fontWeight: "semibold",
          children: ["There are no ", tabs[selectedTab].name.toLowerCase(), " milestones."]
        })
      })
    })]
  });
};